import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'

export default function N25_10_21() {
  return (
    <NoteContainer date={'21/10/2025'} version="20.14.0">
      <VStack w="full">
        <ExclusiveContainer category="ADVERTISEMENT" institutions={['teste', 'treinamento', 'iges']}>
          <VStack w="full">
            <CategoryContainer category="ADVERTISEMENT">
              <Box>
                <TaskTitle important={true}>Retificação das respostas das pesquisas</TaskTitle>
                <TaskBreadcrumb>Pesquisas</TaskBreadcrumb>
                <TaskDescription>
                  Foram retificadas várias respostas de pesquisas, agora na página de formulário respondidos, é possível
                  encontrar somente as respostas das perguntas que existiam na hora que cidadão respondeu, mostrando
                  assim perguntas posteriormente deletadas.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ExclusiveContainer>

        <ModuleContainer moduleName="ATTENDANCES">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Dashboard de atendimentos do profissional</TaskTitle>
                <TaskBreadcrumb>Atendimentos/ relatório</TaskBreadcrumb>
                <TaskDescription>
                  Adicionado dashboard voltado para os atendimentos realizados por profissionais
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ExclusiveContainer category="ADVERTISEMENT" institutions={['teste', 'treinamento', 'iges']}>
          <ModuleContainer moduleName="CITIZEN_PORTAL">
            <VStack w="full">
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle>Redirecionamento dos QR Codes</TaskTitle>
                  <TaskBreadcrumb>Portal Cidadão/ Pesquisa</TaskBreadcrumb>
                  <TaskDescription>
                    Agora os QRCodes que apontavam para o registro da pesquisa via portal cidadão será redirecionado
                    para o registro da pesquisa via módulo Pesquisa
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </VStack>
          </ModuleContainer>
        </ExclusiveContainer>
      </VStack>
    </NoteContainer>
  )
}
